export default __webpack_public_path__ + "static/media/Splenic_Flexure_Set_Up_Female.3a635c18.png";